/**
* Change all chart colors
*/
export const ChartConfig = {
   color: {
      'primary': '#1d2b3b',
      'secondary': '#17c6e9',
      'accent': '#fcc401',
      'success': '#53a548',
      'danger': '#a52422',
      'info': '#48beff',
      'warning': '#fcfc62',
      'white': '#fff',
      'lightGrey':'#E8ECEE'
   },
   lineChartAxesColor: '#E9ECEF',
   legendFontColor: '#AAAEB3', // only works on react chart js 2
   chartGridColor: '#EAEAEA',
   axesColor: '#657786',
   shadowColor: 'rgba(0,0,0,0.3)'
}
